import Axios from "../config/config";

//scrome generate 
export const SCORM_GENERATE_PRESIGNED_URL= async (body) => {
    try {
        const response = await Axios.post('scorm-generate-presigned-url/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};